


export const convertMinutesToDateTime = (minutes) => {
    let now = new Date();
    now.setHours(0, minutes, 0, 0); // Set time based on minutes since midnight
    return now
}